export const careersData = {
  banner: {
    image: "/images/career-banner.jpg",
    alt: "Careers",
  },
  breadcrumb: [
    { label: "HOME", href: "/" },
    { label: "CAREERS", href: "/careers" },
  ],
  title: "Careers",
  sections: {
    welcome: {
      title: "Welcome to Careers at Modepro",
      anchor: "car",
      text: "Teamwork and growth keep people here as they build their careers. A career here translates into continual opportunities to expand on what you can do.",
    },
    openings: {
      title: "Current Openings",
      anchor: "current",
      text: "Apply for the post of immediate requirement of candidates in Production, Q.C., R\u0026D, E.H.S. and other area.",
      subText: "Sutaible candidate can send their resume to ",
      email: "info@modepro.com",
      emailHref: "mailto:info@modepro.com",
    },
  },
};